const config: AppConfig = CONFIG
export default config
